import { Select, MenuItem, Box, Chip, Grid, Typography, Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import { TagEditModal } from '@/screens/exercises/modals/TagEditModal';
import AddIcon from '@mui/icons-material/Add';
import { BodyZone } from '@/generated';
import { filterBodyzones } from '@/utils/bodyzone-filter';
import { TagIntensityList } from './TagIntensityList';
import { useBodyZoneListQuery } from '@/hooks/query-hooks';
import { ExerciseDraft } from '../useExerciseEditor';

export const TagConfiguration = (props: { exercise: ExerciseDraft; updateExericse: (exercise: Partial<ExerciseDraft>) => void }) => {
  const { exercise, updateExericse } = props;
  const { bodyZoneList } = useBodyZoneListQuery();
  const [mainBodyZoneCandidates, setMainBodyZoneCandidates] = useState<BodyZone[]>();
  const [showTagEditModal, setShowTagEditModal] = useState<boolean>(false);

  useEffect(() => {
    setMainBodyZoneCandidates(
      filterBodyzones(bodyZoneList ?? [])?.filter((bz) => bz.zoneTagIds.some((b) => exercise?.muscleIntensities.some((mi) => mi.muscleId === b)) || bz.zoneTagIds.length === 0),
    );
  }, [exercise]);

  return (
    <>
      <TagEditModal
        selectedMuscleIntensities={exercise.muscleIntensities}
        setSelectedMuscleIntensities={(mi) => updateExericse({ muscleIntensities: mi })}
        setShow={setShowTagEditModal}
        show={showTagEditModal}
      />
      <Grid>
        <Stack sx={{ alignItems: 'center', gap: 2 }} direction={'row'}>
          <Typography>Zone</Typography>
          <Select sx={{ my: 1 }} value={exercise.mainBodyZoneId ?? ''} displayEmpty>
            <MenuItem value="">Not Selected</MenuItem>
            {mainBodyZoneCandidates?.map((z, i) => (
              <MenuItem
                key={i}
                selected={z.id === exercise?.mainBodyZoneId}
                value={z.id}
                onClick={(e) => {
                  if (exercise) updateExericse({ mainBodyZoneId: z.id });
                }}
              >
                {z.name}
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <Box>
          <TagIntensityList
            elementClicked={(mi, del) => {
              setShowTagEditModal(true);
            }}
            editable={false}
            muscleIntensities={exercise.muscleIntensities}
          />
        </Box>
        {exercise.muscleIntensities.length === 0 ? (
          <Chip
            sx={{ my: 0.5, display: 'flex', alignItems: 'center', alignContent: 'center', backgroundColor: '#606C38', fontSize: 14 }}
            icon={<AddIcon />}
            onClick={() => setShowTagEditModal(true)}
          />
        ) : (
          <></>
        )}
      </Grid>
    </>
  );
};
